import FilterOption from '../constants/filterOptions';
import SortOption from '../constants/sortOptions';
import AssetTypes from '../constants/assetTypes';
import CategoryAssetType from '../constants/categoryAssetTypes';

/**
 * Utilities for asset search.
 * @class AssetSearchUtils
 */
export default class AssetSearchUtils {
  /**
   * Converts the filter by to individual aspects.
   * @function translateFilterBy
   * @memberof AssetSearchUtils
   * @param  {object} filterBy Filter by to translate
   * @return {object}        Object containing translation
   */
  static translateFilterBy = filterBy => {
    const translation = {
      filterBy: 'none',
      timeRange: 1
    };

    switch (filterBy) {
      case FilterOption.TODAY:
        translation.timeRange = 2;
        break;
      case FilterOption.YESTERDAY:
        translation.timeRange = 3;
        break;
      case FilterOption.FAVORITE:
        translation.filterBy = 'favorite';
        break;
      default:
        translation.filterBy = filterBy;
        break;
    }

    return translation;
  };

  /**
   * Converts the sort by to individual aspects.
   * @function translateSort
   * @memberof AssetSearchUtils
   * @param  {string} sortBy Sort mode to translate
   * @return {object}        Object containing translation
   */
  static translateSortBy = (sortBy, favorite) => {
    const translation = {
      sortBy: 'LastModifiedDateTime',
      sortDirection: 'Desc'
    };

    if (favorite) {
      switch (sortBy) {
        case SortOption.LEAST_RECENT:
          translation.sortBy = 'DateTimeAdded';
          translation.sortDirection = 'Asc';
          return translation;
        case SortOption.MOST_RECENT:
          translation.sortBy = 'DateTimeAdded';
          translation.sortDirection = 'Desc';
          return translation;
        default:
          break;
      }
    }

    switch (sortBy) {
      case SortOption.A_Z:
        translation.sortBy = 'Title';
        translation.sortDirection = 'Asc';
        break;
      case SortOption.Z_A:
        translation.sortBy = 'Title';
        translation.sortDirection = 'Desc';
        break;
      case SortOption.LEAST_RECENT:
        translation.sortBy = 'LastModifiedDateTime';
        translation.sortDirection = 'Asc';
        break;
      case SortOption.MOST_RECENT:
        translation.sortBy = 'LastModifiedDateTime';
        translation.sortDirection = 'Desc';
        break;
      default:
        break;
    }

    return translation;
  };

  /**
   * Translates asset type for filter searching.
   * @param {string} assetType asset type to translate
   */
  static translateAssetType = assetType => {
    switch (assetType) {
      case AssetTypes.GRAPHIC_TEMPLATE:
        return 'GraphicTemplates';
      case AssetTypes.AUTOMATION:
        return 'AutomationTemplates';
      case AssetTypes.STUDIO_CLIP:
        return 'StudioClips';
      case AssetTypes.IMAGE:
      case 'image':
        return 'Images';
      case AssetTypes.VIDEO:
      case 'video':
        return 'Movies';
      default:
        return assetType;
    }
  };

  static translateAssetTypeToCategoryAssetType = assetType => {
    switch (assetType) {
      case AssetTypes.GRAPHIC_TEMPLATE:
      case AssetTypes.AUTOMATION:
      case AssetTypes.STUDIO_CLIP:
      case AssetTypes.IMAGE:
      case 'template':
        return CategoryAssetType.TEMPLATE;
      case 'image':
        return CategoryAssetType.IMAGE;
      case AssetTypes.VIDEO:
      case 'video':
        return CategoryAssetType.VIDEO;
      default:
        return CategoryAssetType.UNKNOWN;
    }
  };
}



// WEBPACK FOOTER //
// ./app/util/assetSearchUtils.js